import { render, staticRenderFns } from "./page-breathing.vue?vue&type=template&id=2d2bc3fe"
import script from "./page-breathing.vue?vue&type=script&lang=ts"
export * from "./page-breathing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports